import { render, staticRenderFns } from "./StrategyType.vue?vue&type=template&id=59affaa5"
import script from "./StrategyType.vue?vue&type=script&lang=js"
export * from "./StrategyType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports